///foodshiftreport/list
export const GET_FOOD_SHIFT_REPORT_LIST = "GET_FOOD_SHIFT_REPORT_LIST";
export const GET_FOOD_SHIFT_REPORT_LIST_SUCCESS =
  "GET_FOOD_SHIFT_REPORT_LIST_SUCCESS";
export const GET_FOOD_SHIFT_REPORT_LIST_FAILURE =
  "GET_FOOD_SHIFT_REPORT_LIST_FAILURE";

///foodshiftreport/search
export const SEARCH_FOOD_SHIFT_REPORT = "SEARCH_FOOD_SHIFT_REPORT";
export const SEARCH_FOOD_SHIFT_REPORT_SUCCESS =
  "SEARCH_FOOD_SHIFT_REPORT_SUCCESS";
export const SEARCH_FOOD_SHIFT_REPORT_FAILURE =
  "SEARCH_FOOD_SHIFT_REPORT_FAILURE";
